import type { RouteObject } from 'react-router-dom';

import { ROUTES } from './routes';

import NotFound from '@/features/NotFound.tsx';
import LandingPage from '@/features/landing/page.tsx';
import RawDataPage from '@/features/raw-data/RawDataPage';
import SiteInformation from '@/features/site-information/components/SiteInformation.tsx';
import SiteManagement from '@/features/site-management/SiteManagement.tsx';
import UserManagementPage from '@/features/user-management/page.tsx';

const routes: RouteObject[] = [
  {
    path: ROUTES.HOME,
    element: <LandingPage />,
  },
  {
    path: ROUTES.SITE_INFORMATION,
    element: <SiteInformation />,
  },
  {
    path: ROUTES.SITE_MANAGEMENT,
    element: <SiteManagement />,
  },
  {
    path: ROUTES.USER_MANAGEMENT,
    element: <UserManagementPage />,
  },
  {
    path: ROUTES.RAW_DATA,
    element: <RawDataPage />,
  },
  {
    path: ROUTES.NOT_FOUND,
    element: <NotFound />,
  },
];

export default routes;
